export const courseCardLayoutByVariant = {
  desktop: {
    maxHeight: 830,
    maxWidth: 400,
    minHeight: 818,
  },
  laptop: {
    maxHeight: 709,
    maxWidth: 343,
    minHeight: 709,
  },
  mobile: {
    maxHeight: 709,
    maxWidth: 343,
    minHeight: 709,
  },
  tablet: {
    maxHeight: 709,
    maxWidth: 343,
    minHeight: 709,
  },
};
